import { Link } from "react-router-dom";

const CertificationAlert = () => {
    return (
        <div className="certification-alert">
            <span className="certification-alert__icon material-icons-outlined">info</span>
            <div className="certification-alert__message">
                <p>
                    A valid certificate is required to authenticate the APIs.{" "}
                    <a href="https://www.six-group.com/en/products-services/financial-information/display-and-delivery-capabilities/six-api/demo.html" target="_blank">Request a trial</a> or see how to <Link to="/documentation#request-in-portal">install your certificate</Link>
                </p>
            </div>
        </div>
    );
};

export default CertificationAlert;